import jwtDecode from "jwt-decode";

export class JwtHelper {

  static decode(token) {
    try {
      return jwtDecode(token)
    } catch (e) {
      return null
    }
  }

  static expiresAt = (token) => {
    if(!token) return 0;
    const decoded = this.decode(token)
    return decoded ? new Date(decoded.exp * 1000) : 0
  }

  static isValid = (token) => {
    return token && (new Date().getTime() < this.expiresAt(token));
  }
}